import { render, staticRenderFns } from "./leo.vue?vue&type=template&id=39e0ccd6&"
import script from "./leo.vue?vue&type=script&lang=js&"
export * from "./leo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports